export const TIMEZONE_ABBREVIATION_OFFSETS: Readonly<Record<string, string>> = {
    Z: '+00:00',
    UT: '+00:00',
    UTC: '+00:00',
    GMT: '+00:00',

    EST: '-05:00', // US Eastern, as defined in RFC 2822
    EDT: '-04:00',
    CST: '-06:00', // US Central, not China (+08:00) or Cuba (-05:00)
    CDT: '-05:00',
    MST: '-07:00', // US Mountain, not Malaysia (+08:00)
    MDT: '-06:00',
    PST: '-08:00', // US Pacific, not Pakistan (+05:00) or Philippines (+08:00)
    PDT: '-07:00',
    AKST: '-09:00',
    AKDT: '-08:00',
    HST: '-10:00',
    HDT: '-09:00',
    HAST: '-10:00',
    HADT: '-09:00',
    AST: '-04:00', // Atlantic, not Arabia (+03:00)
    ADT: '-03:00',
    NST: '-03:30',
    NDT: '-02:30',
    PMST: '-03:00',
    PMDT: '-02:00',
    HNE: '-05:00',
    HAE: '-04:00',
    HNC: '-06:00',
    HAC: '-05:00',
    HNR: '-07:00',
    HAR: '-06:00',
    HNP: '-08:00',
    HAP: '-07:00',
    HNA: '-04:00',
    HAA: '-03:00',
    HNT: '-03:30',
    HAT: '-02:30',

    ART: '-03:00',
    BRT: '-03:00',
    BRST: '-02:00',
    AMT: '-04:00', // Amazon, not Armenia (+04:00)
    AMST: '-03:00',
    FNT: '-02:00',
    CLT: '-04:00',
    CLST: '-03:00',
    COT: '-05:00',
    PET: '-05:00',
    ECT: '-05:00', // Ecuador, not Eastern Caribbean (-04:00)
    BOT: '-04:00',
    PYT: '-04:00',
    PYST: '-03:00',
    UYT: '-03:00',
    UYST: '-02:00',
    VET: '-04:00',
    GYT: '-04:00',
    SRT: '-03:00',
    GFT: '-03:00',
    FKT: '-04:00',
    FKST: '-03:00',
    EAST: '-06:00',
    EASST: '-05:00',
    GALT: '-06:00',

    WET: '+00:00',
    WEST: '+01:00',
    WEZ: '+00:00',
    WESZ: '+01:00',
    BST: '+01:00', // British Summer, not Bangladesh (+06:00)
    CET: '+01:00',
    CEST: '+02:00',
    MET: '+01:00',
    MEST: '+02:00',
    MEZ: '+01:00',
    MESZ: '+02:00',
    EET: '+02:00',
    EEST: '+03:00',
    MSK: '+03:00',
    MSD: '+04:00',
    TRT: '+03:00',
    AZOT: '-01:00',
    AZOST: '+00:00',
    CVT: '-01:00',

    WAT: '+01:00',
    CAT: '+02:00',
    SAST: '+02:00',
    EAT: '+03:00',

    IDT: '+03:00',
    IRST: '+03:30',
    IRDT: '+04:30',
    GST: '+04:00', // Gulf, not South Georgia (-02:00)
    GET: '+04:00',
    AZT: '+04:00',
    SAMT: '+04:00',
    MUT: '+04:00',
    SCT: '+04:00',
    RET: '+04:00',
    AFT: '+04:30',
    PKT: '+05:00',
    UZT: '+05:00',
    TJT: '+05:00',
    TMT: '+05:00',
    MVT: '+05:00',
    TFT: '+05:00',
    YEKT: '+05:00',
    IST: '+05:30', // India, same assumption as MidasDatafeed; Ireland (+01:00) and Israel (+02:00) also use IST
    NPT: '+05:45',
    BDT: '+06:00',
    BTT: '+06:00',
    KGT: '+06:00',
    OMST: '+06:00',
    IOT: '+06:00',
    MMT: '+06:30',
    CCT: '+06:30',
    ICT: '+07:00',
    WIB: '+07:00',
    HOVT: '+07:00',
    KRAT: '+07:00',
    NOVT: '+07:00',
    CXT: '+07:00',
    HKT: '+08:00',
    SGT: '+08:00',
    MYT: '+08:00',
    PHT: '+08:00',
    PHST: '+08:00',
    WITA: '+08:00',
    BNT: '+08:00',
    ULAT: '+08:00',
    IRKT: '+08:00',
    JST: '+09:00',
    KST: '+09:00',
    WIT: '+09:00',
    TLT: '+09:00',
    PWT: '+09:00',
    YAKT: '+09:00',
    VLAT: '+10:00',
    MAGT: '+11:00',
    SAKT: '+11:00',
    SRET: '+11:00',
    PETT: '+12:00',
    ANAT: '+12:00',

    AWST: '+08:00',
    AWDT: '+09:00',
    ACWST: '+08:45',
    ACST: '+09:30',
    ACDT: '+10:30',
    AEST: '+10:00',
    AEDT: '+11:00',
    LHST: '+10:30',
    LHDT: '+11:00',
    CHST: '+10:00',
    PGT: '+10:00',
    CHUT: '+10:00',
    YAPT: '+10:00',
    NFT: '+11:00',
    NFDT: '+12:00',
    NCT: '+11:00',
    VUT: '+11:00',
    SBT: '+11:00',
    PONT: '+11:00',
    KOST: '+11:00',
    NZST: '+12:00',
    NZDT: '+13:00',
    CHAST: '+12:45',
    CHADT: '+13:45',
    FJT: '+12:00',
    FJST: '+13:00',
    TVT: '+12:00',
    GILT: '+12:00',
    MHT: '+12:00',
    WFT: '+12:00',
    NRT: '+12:00',
    TOT: '+13:00',
    PHOT: '+13:00',
    TKT: '+13:00',
    LINT: '+14:00',
    CKT: '-10:00',
    TAHT: '-10:00',
    MART: '-09:30',
    GAMT: '-09:00',
    NUT: '-11:00',
    SST: '-11:00', // Samoa, not Singapore (+08:00)
};
